import React, { ReactNode } from 'react';
interface SubBrandCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  href?: string;
  external?: boolean;
  /** 'launched' for live companies, or a year for an upcoming launch */
  launch?: 'launched' | number;
}
export function SubBrandCard({
  title,
  description,
  icon,
  href = '#',
  external = false,
  launch
}: SubBrandCardProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className="group relative flex flex-col h-full p-8 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl hover:border-blue-200 transition-[box-shadow,border-color] duration-300 overflow-hidden" data-id="element-87" data-mp="ubowfpdaa58v">
      {/* Hover background effect */}
      <div className="absolute inset-0 bg-blue-50/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-88" data-mp="2es1y7dnr98nm" />

      <div className="relative z-10 flex flex-col flex-1" data-id="element-89" data-mp="2joinwcalrv2t">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-slate-50 text-slate-700 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300 mb-6" data-id="element-90" data-mp="tjkjydiswq2e">
          {icon}
        </div>

        <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors duration-300" data-id="element-91" data-mp="kh1owfl9bhqp">
          {title}
        </h3>

        <p className="text-slate-600 leading-relaxed" data-id="element-92" data-mp="akykt46uh914">{description}</p>

        <div className="mt-auto pt-6 flex items-center justify-between gap-4" data-id="element-93" data-mp="am9q58fxuouc">
          {launch === 'launched' ? <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold whitespace-nowrap" data-id="element-94" data-mp="1rva33nl3aa6">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-95" data-mp="3swle93it4g0h" />
              Launched
            </span> : typeof launch === 'number' ? <span className="inline-flex items-center px-3 py-1 rounded-full bg-slate-100 border border-slate-200 text-slate-700 text-xs font-semibold whitespace-nowrap" data-id="element-96" data-mp="3j1jp47oj7dxw">
              Launching {launch}
            </span> : <span data-id="element-97" data-mp="3e9cxzoan5khn" />}

          <span className="flex items-center text-sm font-semibold text-blue-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-[opacity,transform] duration-300" data-id="element-98" data-mp="30cpybdrb0g81">
            Learn more
            <svg className="ml-1 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-99" data-mp="3s3nlk2awj8m4">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-100" data-mp="3jaakue6lj2ph" />
            </svg>
          </span>
        </div>
      </div>
    </a>;
}